import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Dialog from './components/Dialog';
import * as config from './config';
import _ from 'lodash';
import { getArticlesById, getProductByTid } from '@ivymobi/orbit-core/business/productCenter';
import { TenantContext, UserContext, DeviceType } from '../orbit-context';
import { useDialog } from '../products/hooks/use-dialog';
import { fetchConfig } from '../products/services';
import { connect, useSolutionContext } from './context';
const url = 'https://static-cdn.yangbentong.com/5c38710f2b537e266348014f/Master_DeHeSheng_ZCJ/index.html';
const Solutions = () => {

  const history = useHistory();
  const dispatch = useDispatch();
  const user = React.useContext(UserContext);
  const tenant = React.useContext(TenantContext);
  const deviceType = React.useContext(DeviceType);
  const { openDialog } = useSolutionContext();

  // 文章详情测试数据
  const testData = {
    "code": "0000",
    "message": "success",
    "data": [{
      "id": "8368973c-0ef1-4678-8295-da89e53fd963",
      "t_id": "1682ecb5-6541-405b-801b-c0d60f55f644",
      "a_name": "文章",
      "thumbnail": "ww3",
      "parent_id": null,
      "child_ids": null,
      "a_type": 1,
      "info": "info",
      "sort": 0,
      "create_time": "2023-01-03T09:24:46.458Z",
      "update_time": "2023-01-03T09:43:50.888Z",
      "product_ids": [
        "93cb420d-0eb8-4ff6-a5bf-abcdf31f2401",
        "f5b0637c-3fe0-42f6-89c7-dfa08aecde48"
      ],
      "productInfo": [{
        "id": "93cb420d-0eb8-4ff6-a5bf-abcdf31f2401",
        "name": {
          "zh": "2BV系列油（液）环式真空泵"
        },
        "mime": [
          {
            "mimeAlt": [
              {
                "#text": "需更新-2BV系列油（液）环式真空泵.png"
              }
            ],
            "mimeSource": [
              {
                "#text": "https://pim.yangbentong.com/cdn/25d34e57-702c-4f17-a0c9-46b9480cb059.png"
              }
            ],
            "mimePurpose": "thumbnail"
          }
        ]
      }, {
        "id": "f5b0637c-3fe0-42f6-89c7-dfa08aecde48",
        "name": {
          "zh": "2BEC系列水环式真空泵"
        },
        "mime": [
          {
            "mimeAlt": [
              {
                "#text": "需更新-2BEC系列水环真空泵.png"
              }
            ],
            "mimeSource": [
              {
                "#text": "https://pim.yangbentong.com/cdn/5e4ec51c-2b44-4607-99e1-8b438255e7ce.png"
              }
            ],
            "mimePurpose": "thumbnail"
          }
        ]
      }]
    }]
  }

  React.useEffect(() => {
    const onMessage = (event) => {
      console.log('home onMessage --------->>', event.data);
      // const { history, module } = this.props;
      // const prefix = _.get(module, 'config.general.router.prefix');
      if (event.data.type === 'playcanvas:hotspot') {
        const product = config.hotspotConfig[event.data.data];
        if (product && product.type === 'detail') {
          console.log('1 product = ', product);
          // this.hotspotClicked(this.getProduct(product.id));

          // ec77c5fa-d6f2-47be-af2c-fb2ffde9c72c // 智能电网
          // const testArticleId = product.id //'8b3cb901-9c5b-49eb-bb96-2eaa87cbcc4b'
          dispatch(getArticlesById({ user: { token: null, user: null }, tenant: { id: tenant.id }, id: product.id })).then((res) => {
            console.log("======res===", res)
            if (res && res.data && res.data[0]) {
              console.log('文章详情（暂时没有产品列表，测试数据见上面的 testData ） = ', res.data[0])
              openDialog(res.data[0]);
            }
          })

          //进入2D场景
        } else if (product && product.type === 'mid_2d') {
          history.push(`/solutions/${product.id}`);
          //进入3D场景
        } else if (product && product.type === 'mid_3d') {
          history.push(`/solutions/previewDetail/${product.id}`);
        }
      }
    };
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('message', onMessage);
    };

  }, []);

  return <div style={{ position: 'absolute', overflow: 'hidden', left: 0, top: deviceType === 'mobile' ? '50px' : '58px', right: 0, bottom: 0 }}>
    <iframe src={url} style={{ width: '100%', height: '100%', overflow: 'hidden', border: 'none' }}></iframe>
  </div>;
};

export default connect(Solutions);